import FrecuentPoints from './FrecuentPoints';

export default FrecuentPoints;

